export const login_first = `query login_first($input: AuthFirst!){
    login_first(input: $input){
        token
    }
}`;
